<template>
  <div class="equipmentStatus">
    <div class="managementContent">
      <div class="managementMenu">
        <ul>
          <li v-for="(v, i) in menuList"
            :key="i"
            @click="goPage(v.name)">
            <span class="iconfont"
              :class="v.icon"
              :style="{ color: v.color }"></span>
            <p>{{ v.name ? v.name : "" }}</p>
            <h3 :style="{ color: v.color }">
              <span>{{ v.active }}</span>/<span>{{ v.notActive }}</span>/<span>{{ v.alarmNum }}</span>
            </h3>
          </li>
        </ul>
      </div>
      <div class="managementChartsWrap">
        <div class="stateCard">
          <el-radio-group v-model="stateActive"
            size="mini"
            @change="handleChartsData">
            <el-radio-button label="离线数量"></el-radio-button>
            <el-radio-button label="告警数量"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="cardWrap">
          <el-radio-group v-model="cardActive"
            size="mini">
            <el-radio-button label="week">近七天</el-radio-button>
            <el-radio-button label="month">近一个月</el-radio-button>
          </el-radio-group>
        </div>
        <div :style="{ width: '95%', height: '90%', margin: '0 auto' }"
          id="mycharts"></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      menuList: [
        {
          name: "量测设备",
          active: null,
          notActive: null,
          alarmNum: null,
          icon: "icon-Frame",
          color: "#F1EF30",
        },
        {
          name: "用能设备",
          active: null,
          notActive: null,
          alarmNum: null,
          icon: "icon-a-Frame2",
          color: "#3090F6",
        },
        {
          name: "传感器",
          active: null,
          notActive: null,
          alarmNum: null,
          icon: "icon-a-Frame1",
          color: "#28CCCB",
        },
      ],
      cardActive: "week",
      stateActive: "离线数量",
      chartsData: {
        xData: [],
        echartData: [
          {
            name: "量测设备",
            color: "#F1EF30",
            color3: "rgba(241,239,48,.3)",
            color0: "rgba(241,239,48,0)",
            data: [],
          },
          {
            name: "用能设备",
            color: "#3090F6",
            color3: "rgba(48,144,246,.3)",
            color0: "rgba(48,144,246,0)",
            data: [],
          },
          {
            name: "传感器",
            color: "#28CCCB",
            color3: "rgba(40,204,203,.3)",
            color0: "rgba(40,204,203,0)",
            data: [],
          },
        ],
      },
      dataList: [],
    };
  },
  watch: {
    cardActive() {
      this.chartsData.xData = [];
      this.chartsData.echartData.forEach((v) => {
        v.data = [];
      });
      this.getEquipmentOnlineChart();
    },
  },
  methods: {
    goPage(data) {
      this.$router.push({
        name: "equipmentmanagement",
        params: { type: data },
      });
    },
    drawLine() {
      if (document.getElementById("mycharts") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("mycharts"));
      let myChart = this.$echarts.init(document.getElementById("mycharts"));
      myChart.setOption({}, true);
      let option = {
        backgroundColor: "#050b1f",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#57617B",
            },
          },
        },
        legend: {
          left: "20%",
          top: "1%",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          top: "80px",
          left: "50px",
          right: "3%",
          bottom: this.chartsData.xData.length > 12 ? "70px" : "30px",
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: "#CBCBCB",
              fontSize: 14,
              margin: 15,
            },
            axisTick: {
              show: false,
            },
            data: this.chartsData.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 10,
              fontSize: 14,
              color: "#fff",
            },
            splitLine: {
              lineStyle: {
                color: "#082D50",
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: this.chartsData.xData.length > 12 ? true : false,
            startValue: 0, //数据窗口范围的起始数值
            endValue: 11,
            xAxisIndex: [0],
            handleSize: 30,
            height: 10, //组件高度
            bottom: 5, //右边的距离
          },
        ],
        series: [],
      };
      this.chartsData.echartData.forEach((item, index) => {
        option.series.push({
          type: "line",
          name: item.name,
          smooth: true,
          symbol: "arrow",
          symbolSize: 11,
          lineStyle: {
            width: 2,
          },
          areaStyle: {
            color: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: item.color3,
                },
                {
                  offset: 1,
                  color: item.color0,
                },
              ],
              shadowColor: "rgba(0, 0, 0, 0.1)",
              shadowBlur: 10,
            },
          },
          itemStyle: {
            color: item.color,
          },
          data: item.data,
        });
      });
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
    async getEquipmentOnline() {
      let res = await api.equipmentOnline({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.menuList.map((v) => {
          let obj = res.data.data.deviceTypes.find((item) => {
            return item.name === v.name;
          });
          v.active = obj.active;
          v.notActive = obj.notActive;
          v.alarmNum = obj.alarmNum;
        });
      }
    },
    async getEquipmentOnlineChart() {
      let res = await api.equipmentOnlineNumber({
        period: this.cardActive,
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.dataList = res.data.data.charts;
        this.handleChartsData();
      }
    },
    handleChartsData() {
      let data = this.dataList;
      this.chartsData.xData = [];
      this.chartsData.echartData.map((v) => {
        v.data = [];
      });
      data.forEach((v) => {
        this.chartsData.xData.push(dateFtt("yyyy-MM-dd", new Date(v.time)));
        for (let item1 of this.chartsData.echartData) {
          let _index = v.deviceTypes.findIndex((c) => c.name == item1.name);
          if (_index > -1) {
            if (this.stateActive == "离线数量") {
              item1.data.push(v.deviceTypes[_index].notActive);
            } else if (this.stateActive == "告警数量") {
              item1.data.push(v.deviceTypes[_index].alarm);
            }
          }
        }
      });
      this.drawLine();
    },
  },
  created() {
    this.getEquipmentOnline();
    this.getEquipmentOnlineChart();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.equipmentStatus {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #050b1f;

  .managementContent {
    width: 96%;
    height: 98%;
    margin: 0 auto;
    @include setFlexColumn;
    justify-content: space-between;

    .managementMenu {
      height: 30%;
      width: 100%;
      margin-top: 1%;
      @include setFlexCenter;
      ul {
        width: 100%;
        height: 80%;
        @include setFlexStart;
        li {
          cursor: pointer;
          width: 18%;
          height: 100%;
          background: url("~@/assets/images/shebeiguanli/sBgBorder.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          @include setFlexColumn;
          justify-content: center;
          align-items: center;
          margin-right: 20px;

          span {
            // font-size: 20%;
            display: inline-block;
            font-size: 50px;
          }

          p {
            color: #fff;
            margin: 10px 0;
            font-size: 16px;
          }

          h3 {
            font-size: 24px;
            color: #fff;
            span {
              font-size: 24px;
            }
            // span:nth-child(1) {
            //   color: #3ef9fc;
            // }
            // span:nth-child(2) {
            //   color: #9e9e93;
            // }
            // span:nth-child(3) {
            //   color: #e54553;
            // }
          }
        }
      }
    }

    .managementChartsWrap {
      height: 67%;
      width: 100%;
      background: url("~@/assets/images/shebeiguanli/bigBgBorder.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      @include setFlexCenter;
      position: relative;

      .stateCard {
        position: absolute;
        top: 5%;
        left: 2%;
        z-index: 1000;
      }

      .cardWrap {
        position: absolute;
        top: 5%;
        right: 3%;
        z-index: 1000;
      }
    }
  }
}
</style>